export const ADULTS = 'adults';
export const CHILDREN = 'children';
export const INFANTS_IN_SEAT = 'infantsInSeat';
export const INFANTS_IN_LAP = 'infantsInLap';
export const INFANTS = 'infants';
export const PASSPORT = 'P';
export const hostAddress = 'www.allegiantair.com';
